export default function PatientLink(props: { mrn: string }) {
  return <a href={`/patients/${props.mrn}`}>{props.mrn}</a>;
}
